import { cn } from "@/libs/cn";
import {
  Button
} from "@/components/shadcn/button";

import { Icon } from "@iconify-icon/solid";

export const BaseFilter = (props) => {
  return (
    <div class={cn("w-[200px]", props.class)}>
      <div class="flex items-center justify-between p-1 border-b border-black/10 dark:border-white/5">
        <Button variant='outline' class="p-1 flex items-center justify-center h-5 w-6" onClick={props.onBack}>
          <Icon icon="ion:arrow-back-outline" />
        </Button>
        <Button variant='outline' class="p-1 flex items-center justify-center h-5 w-6" onClick={props.onClose}>
          <Icon icon="ion:close" />
        </Button>
      </div>
      <div class="py-1 px-2">
        {props.children}
      </div>
      <div class="px-2">
        <Button variant='outline' class="p-1 flex items-center justify-center w-full h-7 mb-2 text-xs" onClick={props.onClose}>
          Done
        </Button>
      </div>
    </div>
  );
}
